import getProfileAvatarImageUrl from './get-avatar-image-url'

import getProfileCoverImageUrl from './get-cover-image-url'

export default {
  getProfileAvatarImageUrl,
  getProfileCoverImageUrl,
}
